<template>
<div>
  <div class="mask_contents-wrap with_floting st_type02">
    <h1 class="title_type-a">엣모스피어 스카이 <span class="m_block">미세먼지 마스크 KF94 (30매)</span></h1>
    <p class="mask-limit">보다 많은 분들에게 구매 기회를 드리기 위해 예약 주문 가능 수량이 <span class="m_block">대형 1개(30매) 또는 소형 1개(30매)로 제한됩니다.</span></p>
    <!--Start : 마스크 리스트-->
    <div class="list_mask">
      <div class="reservation_product soldout" id="large">
        <div class="choice-area">
          <span class="form_element-radio no_label">
            <input type="radio" id="choice1" name="choice" value="qty1" v-model="qty" :disabled='true'>
            <label for="choice2" class="sp_chk focus">선택</label>
          </span>
        </div>
        <div class="product_img"><img src="./images/mask_big.jpg" alt="" @click="qty='qty1'"></div>
        <div class="product_data">
          <p class="product_name">대형 ({{sku1}})</p>
          <p class="product_price"><span class="product_value">32,000</span>원 / <span class="product_value">1</span>개</p>
        </div>
      </div>
      <div class="reservation_product soldout" id="small">
        <div class="choice-area">
          <span class="form_element-radio no_label">
            <input type="radio" id="choice2" name="choice" value="qty2" v-model="qty" :disabled='true'>
            <label for="choice3" class="sp_chk focus">선택</label>
          </span>
        </div>
        <div class="product_img"><img src="./images/mask_small.jpg" alt="" @click="qty='qty2'"></div>
        <div class="product_data">
          <p class="product_name">소형 ({{sku2}})</p>
          <p class="product_price"><span class="product_value">32,000</span>원 / <span class="product_value">1</span>개</p>
        </div>
      </div>
    </div>
    <!--End : 마스크 리스트-->
    <!--Start : 예약자 정보 입력-->
    <div class="reservation-area">
      <h2 class="title_type-b">예약자 정보 입력</h2>
      <div>
        <div class="new-join-wrap">
          <div class="ipt_area">
            <label for="ko_num" class="form_label">ABO 번호</label>
            <input type="tel" class="form_ipt" id="ko_abo" v-model="search_abo" v-mask="'###########'" @input="aboFocus">
          </div>
          <span class="btn_area"><button type="button" class="btn_type-s" @click="validABO">확인</button></span>
        </div>
        <div class="ipt_msg_area">
          <p class='noti-suc pass' v-show="abo_pass">정상 확인되었습니다.</p>
          <p class='noti-suc fail' v-show="abo_fail">일치하는 정보가 없습니다. 확인 후 다시 입력해주세요.</p>
        </div>
      </div>
    </div>
    <!--End : 예약자 정보 입력-->
    <!--Start : 예약링크 공유 -->
    <div class="reservation-link-area">
      <h2 class="title_type-b">예약링크 공유</h2>
      <div>
        <div class="link_cont_wrap">
          <p class="link_info_share">
            <span class="link_info_share_num">{{sharedCnt}}회 공유</span> /
            <span class="link_info_num">1회</span>
          </p>
          <p class="link_info_txt">*ABO당 <span class="link_info_share_num">1회</span> 공유하실 수 있습니다.</p>
        </div>
      </div>
    </div>
    <!--End : 예약링크 공유 -->
    <div class="footer_btn_area">
      <button v-bind:disabled="isProcessing" type="button" class="btn-share" @click="kakaoShare"><i class="sp_ico" ></i>카카오로 공유하기</button>
    </div>
  </div>
</div>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'
import axios from 'axios'
import VueTheMask from 'vue-the-mask'
/* eslint-disable */
import kakao from './js/kakao.min.js'
/* eslint-disable */
Vue.use(VueTheMask)

export default {
  name: 'atmosphere-mask-reservations',
  data () {
    return {
      search_abo: '',
      search_sku: '',
      ABO_NO: '',
      ABO_NM: '',
      SNS_URL: '',
      sns_title: '',
      thumnail_url: '',
      returnCode: '',
      aboStatus: false,
      // qty: 'qty2',
      qty: '',
      qty1: '0', // sku1의 재고수량
      qty2: '0', // sku2의 재고수량
      stock1: false, // sku2의 재고수량
      stock2: false, // sku2의 재고수량
      isLoading: false,
      sku1: '295882K', // 고정값
      sku2: '295883K',
      sharedCnt: 0,
      abo_pass: false, // abo 확인 성공
      abo_fail: false,  // abo 확인 실패
      isProcessing: false
    }
  },
  methods: {
    validABO () {
      // api 확인
      axios.post(
        process.env.AWS_GATEWAY_URL + '/mask-promotion/main',
        {search_abo: this.search_abo},
        {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(response => {
        if (response.status === 200) {
          if (response.data.searchAbo === null) {
            // abo valid message
            this.abo_pass = false
            this.abo_fail = true
            this.sharedCnt = 0
          } else {
            // abo status
            this.aboStatus = true
            // message
            this.abo_fail = false
            this.abo_pass = true
            // share count
            this.sharedCnt = response.data.searchAbo.share_cnt
            this.ABO_NM = response.data.searchAbo.ABO_NM
            // get stock data
            this.qty1 = response.data.searchQty.Qty1
            this.qty2 = response.data.searchQty.Qty2

            /* if(this.qty1 === 0) { // 대형품절
              $('#large').addClass('soldout')
              $('#choice1').attr('disable', true)
            } else  */
            if(this.qty2 <= 0) { // 소형 품절
              $('#small').addClass('soldout')
              $('#choice2').attr('disable', true)
            } 
          }
        } else {
          console.log('response.status : ', response.status)
          alert('예약 준비 수량이 소진되었습니다')
        }
      }).catch(error => {
        console.log('error : ', error)
        alert('예약 준비 수량이 소진되었습니다')
      })
    },
    aboFocus () { //abo 확인 후 다시 abo 정보를 입력하였을 경우에 확인정보를 리셋.
      this.aboStatus = false
      this.abo_pass = false
      this.abo_fail = false
      this.sharedCnt = 0
    },
    setSearchSku () {
      if (this.qty === 'qty1') {
        this.search_sku = this.sku1
        // set kakao thumnail
        this.thumnail_url = 'https://event.amway.co.kr/mask/images/mask_big.jpg'
        this.sns_title = 'KF94(대형) 30매'
      } else if (this.qty === 'qty2') {
        this.search_sku = this.sku2
        this.thumnail_url = 'https://event.amway.co.kr/mask/images/mask_small.jpg'
        this.sns_title = 'KF94(소형) 30매'
      }
    },
    maskReserv () { // 예약 진행
      // select data set
      this.setSearchSku()
      axios.post(
        process.env.AWS_GATEWAY_URL + '/mask-promotion/reservation',
        {
          search_abo: this.search_abo,
          search_sku: this.search_sku
        },
        {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(response => {
        if (response.status === 200) {
          if (response.data.returnUrl === null) {
            // abo valid message
            alert('죄송합니다. 예약접속자가 많아서 현재 접수가 지연되고 있습니다.\n다시 시도해 주세요.')
          } else {
            this.ABO_NO = response.data.returnUrl.ABO_NO
            this.SNS_URL = response.data.returnUrl.SNS_URL
            this.returnCode = response.data.returnUrl.returnCode

            if(this.returnCode === '200'){
              // reservation success 
              this.setKakao()
              this.validABO()
            }
            else {
              alert('예약 준비 수량이 소진되었습니다')
              // TODO : message alert?
            }
          }
        } else {
          console.log('response.status : ', response.status)
          alert('예약 준비 수량이 소진되었습니다')
        }
      }).catch(error => {
        console.log('error : ', error)
        alert('예약 준비 수량이 소진되었습니다')
      })
    },
    kakaoShare () {
      this.isProcessing = true
      // aboStatus check
      if (!this.aboStatus) {
        alert('ABO 번호를 입력하시고 확인버튼을 눌러주세요')
        this.isProcessing = false
        return
      }
      
      // share count check
      if (this.sharedCnt >= 1) {
        alert('ABO당 1회 공유하실 수 있습니다.')
        this.isProcessing = false
        return
      }

      // stock check
      if (this.qty === 'qty1') {
        alert('엣모스피어 스카이 미세먼지 마스크 대형 (295882K)은 예약 종료 된 상품입니다')
        this.isProcessing = false
        return
        /* if (this.qty1 <= '0') {
          alert('엣모스피어 스카이 미세먼지 마스크 대형 (295882K)은 예약 종료 된 상품입니다')
          return
        } */
      } else if (this.qty === 'qty2') {
        if (!this.qty2 <= '0') {
          alert('엣모스피어 스카이 미세먼지 마스크 소형 (295883K)은 예약 종료 된 상품입니다')
          this.isProcessing = false
          return
        }
      } else {
        alert('예약 준비 수량이 소진되었습니다')
        this.isProcessing = false
        return
      }
      // reservation api
      this.maskReserv()
      this.isProcessing = false
    },
    setKakao(){
      /* eslint-disable */
      try {
        Kakao.Link.sendDefault({
          objectType: 'feed',
          content: {
            title: '엣모스피어 스카이 미세먼지 마스크' + this.sns_title,
            description:  this.ABO_NM + '님이 공유하신 마스크 구매 예약 링크를 확인해보세요',
            imageUrl:
              this.thumnail_url,
            link: {
              mobileWebUrl: this.SNS_URL,
              webUrl: this.SNS_URL,
            },
            /* serverCallbackArgs: { // 콜백 파라미터 설정
              key: 'test'
            } */
          },
          buttons: [
            {
              title: '예약링크 확인',
              link: {
                mobileWebUrl: this.SNS_URL,
                webUrl: this.SNS_URL,
              },
            },
          ],
        })
      }catch (err) {
        console.log(err)
      }
    }, 
    stockCheck () {
      // stock check & soldout 
      axios.post(
        process.env.AWS_GATEWAY_URL + '/mask-promotion/main',
        {search_abo: ''},
        {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(response => {
        if (response.status === 200) {
          if (response.data.searchQty != null) {
            // stock check and soldout image set
            this.qty1 = response.data.searchQty.Qty1
            this.qty2 = response.data.searchQty.Qty2
            /* if(this.qty1 <= 0) { // 대형품절
              $('#large').addClass('soldout')
              $('#choice1').attr('disable', true)
            } else  */
            if(this.qty2 <= 0) { // 소형 품절
              $('#small').addClass('soldout')
              $('#choice2').attr('disable', true)
            } 
          } else {
            // error message set
            alert('죄송합니다. 예약접속자가 많아서 현재 접수가 지연되고 있습니다.\n다시 시도해 주세요.1')
          }
        } else {
          console.log('response.status : ', response.status)
          alert('예약 준비 수량이 소진되었습니다')
        }
      }).catch(error => {
        console.log('error : ', error)
        alert('예약 준비 수량이 소진되었습니다')
      })
    }
  },
  mounted () {
    /* eslint-disable */
    try {
      Kakao.init(process.env.KAKAO_AUTH_KEY)
    } catch (err) {
      console.log("Kakao Talk Initialize Error")
    }
    
    // abo input label
    window.addEventListener('DOMContentLoaded', function () {
      $('.form_ipt').not('.ipt_area_change .form_ipt').each(function() {
        var thisInput = $(this);
        var paDiv = thisInput.parent();
        thisInput.on('focus focusout', function (e) {
          if (e.type === 'focus') {
            if (!paDiv.hasClass('on')) {
              paDiv.addClass('on');
            }
          } else if (e.type === 'focusout') {
            if (thisInput.val() == "") {
              paDiv.removeClass('on');
            }
          }
        });
      });
    });
    /* eslint-enable */

    // stock check
    this.stockCheck()
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Noto+Sans+KR:300,400,500,700&subset=korean');
@import './css/mask2.css';
</style>



// WEBPACK FOOTER //
// src/views/atmosphere-mask/share.vue